<div class="container-banner" #downloadAppBanner>
    <div class="text">
        <p>Looking for a Personalized Diet Plan?</p>
    </div>
    <img
        src="https://img.clearcals.com/site/images/hint/arrow.webp"
        alt="arrow"
    />
    <a
        (click)="clickDownloadAppBanner()"
        href="https://clearcals.com/products/hint"
        target="_blank"
        >Try the Hint app</a
    >
</div>
